import React from 'react'

const NotReadyIndicator = () => (
  <div className='activity-board__nr'>NOT READY</div>
)

export default NotReadyIndicator
